import { gql } from "@apollo/client";

const InputsFragment = gql`
  fragment InputsFragment on DownloadPart {
    id
    dirty_row_count
    dirty_row_status
    new_dirty_row_count
    new_dirty_row_status
    legacy_flow_source_id
    row_count
    source_table {
      name
      project
    }
    download {
      id
      created
      finished
      handle
      purpose
      progress
      report_datetime {
        short
        long
        long_utc
        iso
      }
      source_tables {
        name
        project
      }
      started
      status
    }
  }
`;

const UPLOAD_QUERY_WITH_DOWNLOADS = gql`
  query upload_downloads($id: String!) {
    upload(id: $id) {
      inputs {
        ...InputsFragment
      }
    }
  }
  ${InputsFragment}
`;

const ALL_UPLOADS_QUERY_WITH_DOWNLOADS = gql`
  query all_upload_downloads($id: String, $first: Int, $after: String, $last: Int, $before: String) {
    uploads(id: $id, first: $first, after: $after, last: $last, before: $before) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        cursor
        node {
          id
          name
          project
          handle
          row_count
          created
          started
          finished
          report_datetime {
            short
            long
            long_utc
            iso
          }
          status
          destination

          inputs {
            ...InputsFragment
          }
        }
      }
    }
  }
  ${InputsFragment}
`;

const UPLOADS_FOR_DOWNLOAD_QUERY = gql`
  query upload_for_downloads(
    $id: String
    $download_part_id: String
    $first: Int
    $after: String
    $last: Int
    $before: String
    $downloadPartIds: [String]
  ) {
    uploads(
      id: $id
      download_part_id: $download_part_id
      first: $first
      after: $after
      last: $last
      before: $before
      downloadPartIds: $downloadPartIds
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        cursor
        node {
          id
          name
          project
          handle
          row_count
          created
          purpose
          started
          finished
          report_datetime {
            short
            long
            long_utc
            iso
          }
          status
          destination
        }
      }
    }
  }
`;

const UPLOAD_FILES_QUERY = gql`
  query uploads(
    $name: String
    $names: [String]
    $project: String
    $projects: [String]
    $purpose: String
    $report_datetime_after: Date
    $report_datetime_before: Date
    $search: String
    $status: String
    $uploaded_after: Date
    $uploaded_before: Date
    $destination: String
    $first: Int
    $after: String
    $last: Int
    $before: String
    $sortBy: DataGridSortableColumns
    $sortDirection: SortDirection
  ) {
    uploads(
      name: $name
      names: $names
      project: $project
      projects: $projects
      purpose: $purpose
      report_datetime_after: $report_datetime_after
      report_datetime_before: $report_datetime_before
      search: $search
      status: $status
      uploaded_after: $uploaded_after
      uploaded_before: $uploaded_before
      destination: $destination
      first: $first
      after: $after
      last: $last
      before: $before
      sortBy: $sortBy
      sortDirection: $sortDirection
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        cursor
        node {
          id
          name
          project
          purpose
          handle
          row_count
          created
          started
          finished
          report_datetime {
            short
            long
            long_utc
            iso
          }
          status
          destination
        }
      }
    }
  }
`;

export {
  ALL_UPLOADS_QUERY_WITH_DOWNLOADS,
  UPLOAD_FILES_QUERY,
  UPLOAD_QUERY_WITH_DOWNLOADS,
  UPLOADS_FOR_DOWNLOAD_QUERY,
};
